<mat-label class="subHeading">Weighted Premium (₹)<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="weighted_premium" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="9" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="9" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
